import z from 'zod';

// TODO Levente: move to the shared core package
const fontFamilies = z.enum([
  'Open Sans, sans-serif',
  'Arial, sans-serif',
  'Brush Script MT, cursive',
  'Courier New, monospace',
  'Garamond, serif',
  'Georgia, serif',
  'Tahoma, sans-serif',
  'Times New Roman, serif',
  'Trebuchet MS, sans-serif',
  'Verdana, sans-serif',
]);

// TODO duplicate from apps/web/lib/
// TODO Levente: move to the shared core package
export const lightTheme = {
  backgroundImage: '',
  backgroundImageFit: 'cover',
  backgroundImageAttachment: 'scroll',
  backgroundOpacity: 1,
  header: {
    height: 256,
    inheritWidthFrom: 'container',
    textAreaWidth: 512,
    overlapEnabled: false,
    backgroundImageOpacity: 1,
    backgroundImageFit: 'cover',
    logoPositionX: 'right',
    logoPositionY: 'top',
    titlePositionX: 'left',
    titlePositionY: 'bottom',
    descriptionPositionX: 'left',
    descriptionPositionY: 'bottom',
  },
  themeName: 'default',
  colorPalette: 'light',
  isPanelless: false,
  cssVariables: {
    '--sjs-general-backcolor': 'rgba(245, 245, 245, 1)',
    '--sjs-general-backcolor-dark': 'rgba(239, 239, 239, 1)',
    '--sjs-general-backcolor-dim': '#ffffff',
    '--sjs-general-backcolor-dim-light': 'rgba(255, 255, 255, 0.5)',
    '--sjs-general-backcolor-dim-dark': 'rgba(237, 237, 237, 1)',
    '--sjs-general-forecolor': 'rgba(0, 0, 0, 0.91)',
    '--sjs-general-forecolor-light': 'rgba(0, 0, 0, 0.45)',
    '--sjs-general-dim-forecolor': 'rgba(0, 0, 0, 0.91)',
    '--sjs-general-dim-forecolor-light': 'rgba(0, 0, 0, 0.45)',
    '--sjs-primary-backcolor': 'rgba(162, 145, 196, 1)',
    '--sjs-primary-backcolor-light': 'rgba(162, 145, 196, 0.1)',
    '--sjs-primary-backcolor-dark': 'rgba(162, 145, 196, 1)',
    '--sjs-primary-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-primary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-base-unit': '8px',
    '--sjs-corner-radius': '4px',
    '--sjs-secondary-backcolor': 'rgba(255, 152, 20, 1)',
    '--sjs-secondary-backcolor-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-secondary-backcolor-semi-light': 'rgba(255, 152, 20, 0.25)',
    '--sjs-secondary-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-secondary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-shadow-small': '0px 0px 0px 1px rgba(140, 140, 140, 0.2)',
    '--sjs-shadow-small-reset': '0px 0px 0px 0px rgba(140, 140, 140, 0.2)',
    '--sjs-shadow-medium':
      '0px 0px 0px 2px rgba(0, 0, 0, 0.08),0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    '--sjs-shadow-large': '0px 8px 16px 0px rgba(0, 0, 0, 0.08)',
    '--sjs-shadow-inner': '0px 0px 0px 2px rgba(0, 0, 0, 0.1)',
    '--sjs-shadow-inner-reset': '0px 0px 0px 0px rgba(0, 0, 0, 0.1)',
    '--sjs-border-light': 'rgba(0, 0, 0, 0.1)',
    '--sjs-border-default': 'rgba(0, 0, 0, 0.1)',
    '--sjs-border-inside': 'rgba(0, 0, 0, 0.16)',
    '--sjs-special-red': 'rgba(229, 10, 62, 1)',
    '--sjs-special-red-light': 'rgba(229, 10, 62, 0.1)',
    '--sjs-special-red-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-green': 'rgba(25, 179, 148, 1)',
    '--sjs-special-green-light': 'rgba(25, 179, 148, 0.1)',
    '--sjs-special-green-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-blue': 'rgba(67, 127, 217, 1)',
    '--sjs-special-blue-light': 'rgba(67, 127, 217, 0.1)',
    '--sjs-special-blue-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-special-yellow': 'rgba(255, 152, 20, 1)',
    '--sjs-special-yellow-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-special-yellow-forecolor': 'rgba(255, 255, 255, 1)',
    '--sjs-article-font-xx-large-textDecoration': 'none',
    '--sjs-article-font-xx-large-fontWeight': '700',
    '--sjs-article-font-xx-large-fontStyle': 'normal',
    '--sjs-article-font-xx-large-fontStretch': 'normal',
    '--sjs-article-font-xx-large-letterSpacing': '0',
    '--sjs-article-font-xx-large-lineHeight': '64px',
    '--sjs-article-font-xx-large-paragraphIndent': '0px',
    '--sjs-article-font-xx-large-textCase': 'none',
    '--sjs-article-font-x-large-textDecoration': 'none',
    '--sjs-article-font-x-large-fontWeight': '700',
    '--sjs-article-font-x-large-fontStyle': 'normal',
    '--sjs-article-font-x-large-fontStretch': 'normal',
    '--sjs-article-font-x-large-letterSpacing': '0',
    '--sjs-article-font-x-large-lineHeight': '56px',
    '--sjs-article-font-x-large-paragraphIndent': '0px',
    '--sjs-article-font-x-large-textCase': 'none',
    '--sjs-article-font-large-textDecoration': 'none',
    '--sjs-article-font-large-fontWeight': '700',
    '--sjs-article-font-large-fontStyle': 'normal',
    '--sjs-article-font-large-fontStretch': 'normal',
    '--sjs-article-font-large-letterSpacing': '0',
    '--sjs-article-font-large-lineHeight': '40px',
    '--sjs-article-font-large-paragraphIndent': '0px',
    '--sjs-article-font-large-textCase': 'none',
    '--sjs-article-font-medium-textDecoration': 'none',
    '--sjs-article-font-medium-fontWeight': '700',
    '--sjs-article-font-medium-fontStyle': 'normal',
    '--sjs-article-font-medium-fontStretch': 'normal',
    '--sjs-article-font-medium-letterSpacing': '0',
    '--sjs-article-font-medium-lineHeight': '32px',
    '--sjs-article-font-medium-paragraphIndent': '0px',
    '--sjs-article-font-medium-textCase': 'none',
    '--sjs-article-font-default-textDecoration': 'none',
    '--sjs-article-font-default-fontWeight': '400',
    '--sjs-article-font-default-fontStyle': 'normal',
    '--sjs-article-font-default-fontStretch': 'normal',
    '--sjs-article-font-default-letterSpacing': '0',
    '--sjs-article-font-default-lineHeight': '28px',
    '--sjs-article-font-default-paragraphIndent': '0px',
    '--sjs-article-font-default-textCase': 'none',
    '--sjs-question-background': 'rgba(245, 245, 245, 1)',
    '--sjs-questionpanel-hovercolor': 'rgba(177, 160, 204, 1)',
    '--sjs-editor-background': 'rgba(255, 255, 255, 1)',
    '--sjs-editorpanel-hovercolor': 'rgba(255, 255, 255, 1)',
    '--sjs-font-pagedescription-color': 'rgba(0, 0, 0, 0.8)',
    '--sjs-font-questiondescription-color': 'rgba(0, 0, 0, 0.6)',
    '--sjs-questionpanel-backcolor': 'rgba(245, 245, 245, 1)',
    '--sjs-editorpanel-backcolor': 'rgba(255, 255, 255, 0.5)',
    '--sjs-font-pagedescription-family': 'Georgia, serif',
    '--sjs-font-questiontitle-family': 'Verdana, sans-serif',
    '--sjs-font-questiondescription-family': 'Verdana, sans-serif',
    '--sjs-font-editorfont-family': 'Verdana, sans-serif',
    '--sjs-font-editorfont-placeholdercolor': 'rgba(0, 0, 0, 0.45)',
    '--sjs-font-headertitle-size': '24px',
    '--sjs-font-headerdescription-family': 'Verdana, sans-serif',
    '--sjs-font-headertitle-family': 'Verdana, sans-serif',
    '--sjs-font-pagetitle-family': 'Verdana, sans-serif',
    '--sjs-font-questiontitle-color': 'rgba(77, 77, 77, 0.91)',
    '--sjs-font-pagetitle-color': 'rgba(89, 88, 90, 0.91)',
    '--sjs-header-backcolor': 'var(--sjs-primary-backcolor)',
  },
  headerView: 'advanced',
};

// TODO duplicate from apps/web/lib/
// TODO Levente: move to the shared core package
export const darkTheme = {
  themeName: 'default',
  colorPalette: 'dark',
  isPanelless: false,
  backgroundImage: '',
  backgroundOpacity: 1,
  backgroundImageAttachment: 'scroll',
  backgroundImageFit: 'cover',
  cssVariables: {
    '--sjs-corner-radius': '4px',
    '--sjs-base-unit': '8px',
    '--sjs-shadow-small': '0px 0px 0px 2px rgba(255, 255, 255, 0.12)',
    '--sjs-shadow-inner': '0px 0px 0px 2px rgba(255, 255, 255, 0.1)',
    '--sjs-border-default': 'rgba(255, 255, 255, 0.1)',
    '--sjs-border-light': 'rgba(255, 255, 255, 0.1)',
    '--sjs-general-backcolor': 'rgba(52, 52, 52, 1)',
    '--sjs-general-backcolor-dark': 'rgba(58, 58, 58, 1)',
    '--sjs-general-backcolor-dim-light': 'rgba(47, 47, 47, 1)',
    '--sjs-general-backcolor-dim-dark': 'rgba(53, 53, 53, 1)',
    '--sjs-general-forecolor': 'rgba(255, 255, 255, 0.78)',
    '--sjs-general-forecolor-light': 'rgba(255, 255, 255, 0.42)',
    '--sjs-general-dim-forecolor': 'rgba(255, 255, 255, 0.79)',
    '--sjs-general-dim-forecolor-light': 'rgba(255, 255, 255, 0.45)',
    '--sjs-secondary-backcolor': 'rgba(255, 152, 20, 1)',
    '--sjs-secondary-backcolor-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-secondary-backcolor-semi-light': 'rgba(255, 152, 20, 0.25)',
    '--sjs-secondary-forecolor': 'rgba(48, 48, 48, 1)',
    '--sjs-secondary-forecolor-light': 'rgba(48, 48, 48, 0.25)',
    '--sjs-shadow-small-reset': '0px 0px 0px 0px rgba(255, 255, 255, 0.12)',
    '--sjs-shadow-medium': '0px 0px 0px 2px rgba(255, 255, 255, 0.1)',
    '--sjs-shadow-large': '0px 8px 16px 0px rgba(0, 0, 0, 0.1)',
    '--sjs-shadow-inner-reset': '0px 0px 0px 0px rgba(255, 255, 255, 0.1)',
    '--sjs-border-inside': 'rgba(255, 255, 255, 0.08)',
    '--sjs-special-red-forecolor': 'rgba(48, 48, 48, 1)',
    '--sjs-special-green': 'rgba(36, 197, 164, 1)',
    '--sjs-special-green-light': 'rgba(36, 197, 164, 0.1)',
    '--sjs-special-green-forecolor': 'rgba(48, 48, 48, 1)',
    '--sjs-special-blue': 'rgba(91, 151, 242, 1)',
    '--sjs-special-blue-light': 'rgba(91, 151, 242, 0.1)',
    '--sjs-special-blue-forecolor': 'rgba(48, 48, 48, 1)',
    '--sjs-special-yellow': 'rgba(255, 152, 20, 1)',
    '--sjs-special-yellow-light': 'rgba(255, 152, 20, 0.1)',
    '--sjs-special-yellow-forecolor': 'rgba(48, 48, 48, 1)',
    '--sjs-article-font-xx-large-textDecoration': 'none',
    '--sjs-article-font-xx-large-fontWeight': '700',
    '--sjs-article-font-xx-large-fontStyle': 'normal',
    '--sjs-article-font-xx-large-fontStretch': 'normal',
    '--sjs-article-font-xx-large-letterSpacing': '0',
    '--sjs-article-font-xx-large-lineHeight': '64px',
    '--sjs-article-font-xx-large-paragraphIndent': '0px',
    '--sjs-article-font-xx-large-textCase': 'none',
    '--sjs-article-font-x-large-textDecoration': 'none',
    '--sjs-article-font-x-large-fontWeight': '700',
    '--sjs-article-font-x-large-fontStyle': 'normal',
    '--sjs-article-font-x-large-fontStretch': 'normal',
    '--sjs-article-font-x-large-letterSpacing': '0',
    '--sjs-article-font-x-large-lineHeight': '56px',
    '--sjs-article-font-x-large-paragraphIndent': '0px',
    '--sjs-article-font-x-large-textCase': 'none',
    '--sjs-article-font-large-textDecoration': 'none',
    '--sjs-article-font-large-fontWeight': '700',
    '--sjs-article-font-large-fontStyle': 'normal',
    '--sjs-article-font-large-fontStretch': 'normal',
    '--sjs-article-font-large-letterSpacing': '0',
    '--sjs-article-font-large-lineHeight': '40px',
    '--sjs-article-font-large-paragraphIndent': '0px',
    '--sjs-article-font-large-textCase': 'none',
    '--sjs-article-font-medium-textDecoration': 'none',
    '--sjs-article-font-medium-fontWeight': '700',
    '--sjs-article-font-medium-fontStyle': 'normal',
    '--sjs-article-font-medium-fontStretch': 'normal',
    '--sjs-article-font-medium-letterSpacing': '0',
    '--sjs-article-font-medium-lineHeight': '32px',
    '--sjs-article-font-medium-paragraphIndent': '0px',
    '--sjs-article-font-medium-textCase': 'none',
    '--sjs-article-font-default-textDecoration': 'none',
    '--sjs-article-font-default-fontWeight': '400',
    '--sjs-article-font-default-fontStyle': 'normal',
    '--sjs-article-font-default-fontStretch': 'normal',
    '--sjs-article-font-default-letterSpacing': '0',
    '--sjs-article-font-default-lineHeight': '28px',
    '--sjs-article-font-default-paragraphIndent': '0px',
    '--sjs-article-font-default-textCase': 'none',
    '--sjs-general-backcolor-dim': 'rgba(47, 47, 47, 1)',
    '--sjs-primary-backcolor': 'rgba(120, 156, 210, 1)',
    '--sjs-primary-backcolor-dark': 'rgba(146, 181, 235, 1)',
    '--sjs-primary-backcolor-light': 'rgba(255, 255, 255, 0.1)',
    '--sjs-primary-forecolor': 'rgba(32, 32, 32, 1)',
    '--sjs-primary-forecolor-light': 'rgba(32, 32, 32, 0.25)',
    '--sjs-special-red': 'rgba(254, 76, 108, 1)',
    '--sjs-special-red-light': 'rgba(254, 76, 108, 0.1)',
    '--sjs-header-backcolor': 'var(--sjs-primary-backcolor)',
  },
  headerView: 'advanced',
};

// TODO Levente: move to the shared core package
export function themeSchemaWithColorPalette(colorPalette: string[]) {
  const colorSchema = z
    .enum(colorPalette as [string, ...string[]])
    .describe('Color in HEX');

  const fontSchema = z.object({
    color: colorSchema.describe(
      'Font color have to be contrasted from background color',
    ),
    fontFamily: fontFamilies,
    fontSize: z.string().describe('CSS font-size in PIXELS'),
    fontWeight: z.number().describe('CSS font-weight'),
  });

  return z.object({
    header: z.object({
      height: z.number().describe('Height of the header in pixels'),
      inheritWidthFrom: z.enum(['container', 'survey']),
      backgroundColor: colorSchema,
      title: fontSchema.extend({
        positionX: z.enum(['left', 'center', 'right']),
        positionY: z.enum(['top', 'middle', 'bottom']),
      }),
      description: fontSchema.extend({
        positionX: z.enum(['left', 'center', 'right']),
        positionY: z.enum(['top', 'middle', 'bottom']),
      }),
    }),
    body: z.object({
      backgroundColor: colorSchema,
      title: fontSchema,
      description: fontSchema,
      questionPanel: z
        .object({
          hidePanel: z
            .boolean()
            .describe(
              "If panel's background color is the same as body background color, set to true",
            ),
          backgroundColor: colorSchema,
          borderRadius: z.string(),
          boxShadow: z.string(),
          sequentialNumber: z.object({
            color: colorSchema,
          }),
          title: fontSchema,
          description: fontSchema,
        })
        .describe('The card'),
      inputControl: fontSchema.extend({
        backgroundColor: colorSchema,
        foreColor: colorSchema,
        focusedBoxShadow: colorSchema,
        borderRadius: z.string(),
        placeholderColor: colorSchema,
      }),
      button: z
        .object({
          backgroundColor: colorSchema,
          foreColor: colorSchema,
          hoverBackgroundColor: colorSchema,
          borderRadius: z.string(),
          focusedBoxShadow: colorSchema,
        })
        .describe('The primary button'),
      errorMessage: z.object({
        backgroundColor: colorSchema,
        foreColor: colorSchema,
      }),
    }),
  });
}
